/* tslint:disable */
/* eslint-disable */
/**
 * TOM ADMIN SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerDamageLocationDto } from '../model';
// @ts-ignore
import type { CreateContainerDamageLocationCommand } from '../model';
// @ts-ignore
import type { UpdateContainerDamageLocationCommand } from '../model';
/**
 * ContainerDamageLocationsApi - axios parameter creator
 */
export const ContainerDamageLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('containerDamageLocationsDelete', 'id', id)
            const localVarPath = `/admin/api/ContainerDamageLocations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/ContainerDamageLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateContainerDamageLocationCommand} [createContainerDamageLocationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsPost: async (createContainerDamageLocationCommand?: CreateContainerDamageLocationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/ContainerDamageLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContainerDamageLocationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContainerDamageLocationCommand} [updateContainerDamageLocationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsPut: async (id: number, updateContainerDamageLocationCommand?: UpdateContainerDamageLocationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('containerDamageLocationsPut', 'id', id)
            const localVarPath = `/admin/api/ContainerDamageLocations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContainerDamageLocationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerDamageLocationsApi - functional programming interface
 */
export const ContainerDamageLocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerDamageLocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageLocationsDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageLocationsDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageLocationsApi.containerDamageLocationsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageLocationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerDamageLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageLocationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageLocationsApi.containerDamageLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateContainerDamageLocationCommand} [createContainerDamageLocationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageLocationsPost(createContainerDamageLocationCommand?: CreateContainerDamageLocationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageLocationsPost(createContainerDamageLocationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageLocationsApi.containerDamageLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContainerDamageLocationCommand} [updateContainerDamageLocationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageLocationsPut(id: number, updateContainerDamageLocationCommand?: UpdateContainerDamageLocationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageLocationsPut(id, updateContainerDamageLocationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageLocationsApi.containerDamageLocationsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerDamageLocationsApi - factory interface
 */
export const ContainerDamageLocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerDamageLocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.containerDamageLocationsDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerDamageLocationDto>> {
            return localVarFp.containerDamageLocationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateContainerDamageLocationCommand} [createContainerDamageLocationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsPost(createContainerDamageLocationCommand?: CreateContainerDamageLocationCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.containerDamageLocationsPost(createContainerDamageLocationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContainerDamageLocationCommand} [updateContainerDamageLocationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageLocationsPut(id: number, updateContainerDamageLocationCommand?: UpdateContainerDamageLocationCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.containerDamageLocationsPut(id, updateContainerDamageLocationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainerDamageLocationsApi - object-oriented interface
 */
export class ContainerDamageLocationsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageLocationsDelete(id: number, options?: RawAxiosRequestConfig) {
        return ContainerDamageLocationsApiFp(this.configuration).containerDamageLocationsDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageLocationsGet(options?: RawAxiosRequestConfig) {
        return ContainerDamageLocationsApiFp(this.configuration).containerDamageLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateContainerDamageLocationCommand} [createContainerDamageLocationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageLocationsPost(createContainerDamageLocationCommand?: CreateContainerDamageLocationCommand, options?: RawAxiosRequestConfig) {
        return ContainerDamageLocationsApiFp(this.configuration).containerDamageLocationsPost(createContainerDamageLocationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateContainerDamageLocationCommand} [updateContainerDamageLocationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageLocationsPut(id: number, updateContainerDamageLocationCommand?: UpdateContainerDamageLocationCommand, options?: RawAxiosRequestConfig) {
        return ContainerDamageLocationsApiFp(this.configuration).containerDamageLocationsPut(id, updateContainerDamageLocationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

